module.exports = __webpack_public_path__ + "modules/platform/img/empty-image-default.png";